import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Heart, MessageSquare, Share2, Send } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { useApp } from '../store';
export function PostPage() {
  const {
    id
  } = useParams();
  const {
    posts,
    addComment,
    requireIdentity,
    user
  } = useApp();
  const post = posts.find(p => p.id === id);
  const [liked, setLiked] = useState(false);
  const [draft, setDraft] = useState('');
  if (!post) {
    return <div className="text-center py-20" data-id="element-581" data-mp="1530swxbtodq7">
        <p className="text-navy-500 mb-4" data-id="element-582" data-mp="151zimv2mrv9j">That post couldn't be found.</p>
        <Link to="/feed" className="text-gold-600 font-semibold" data-id="element-583" data-mp="105itbxjp3auv">
          Back to Feed
        </Link>
      </div>;
  }
  const comments = post.comments;
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!draft.trim()) return;
    // Keep the draft if the visitor still needs to introduce themselves.
    if (!requireIdentity()) return;
    addComment(post.id, draft.trim());
    setDraft('');
  };
  return <div className="max-w-2xl mx-auto" data-id="element-584" data-mp="290arolo0pxob">
      <PageHeader title="" backTo="/feed" backLabel="Back to Feed" data-id="element-585" data-mp="2ds2aga0xmz3w" />

      <article className="bg-white rounded-xl border border-navy-100 overflow-hidden" data-id="element-586" data-mp="2duf1rdskyltm">
        <div className="p-5" data-id="element-587" data-mp="1z5925optytl7">
          <div className="flex items-center gap-3 mb-4" data-id="element-588" data-mp="242irl4d7z591">
            <img src={post.avatar} alt={post.author} className="w-12 h-12 rounded-full object-cover" data-id="element-589" data-mp="24326ec7kpdiu" />
            <div data-id="element-590" data-mp="2wrpzgtykd76y">
              <p className="text-sm font-bold text-navy-900" data-id="element-591" data-mp="2wq52yysove6g">{post.author}</p>
              <p className="text-xs text-navy-400" data-id="element-592" data-mp="2irycw4tzeihc">
                {post.role} · {post.time}
              </p>
            </div>
            <span className="ml-auto text-[0.65rem] font-semibold uppercase tracking-wide text-navy-600 bg-navy-50 px-2 py-1 rounded-full" data-id="element-593" data-mp="2mrpb2tlu80vw">
              {post.team}
            </span>
          </div>
          <p className="text-navy-800 leading-relaxed" data-id="element-594" data-mp="1bemwg43atled">{post.body}</p>
        </div>
        {post.image && <img src={post.image} alt="" className="w-full max-h-96 object-cover" data-id="element-595" data-mp="3dzzayfgvchef" />}
        <div className="flex items-center gap-1 px-5 py-3 border-t border-navy-50" data-id="element-596" data-mp="34api2xe7aup9">
          <button onClick={() => setLiked(v => !v)} className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${liked ? 'text-gold-600' : 'text-navy-500 hover:bg-navy-50'}`} data-id="element-597" data-mp="348mk9r6t3x9z">
            <Heart className={`w-4 h-4 ${liked ? 'fill-gold-500 text-gold-500' : ''}`} data-id="element-598" data-mp="2q9wjo1ks3fgv" />{' '}
            {post.likes + (liked ? 1 : 0)}
          </button>
          <span className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-navy-500" data-id="element-599" data-mp="2gd9z7dwd6qfd">
            <MessageSquare className="w-4 h-4" data-id="element-600" data-mp="jl00icm44usv" /> {comments.length}
          </span>
          <button className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-navy-500 hover:bg-navy-50 rounded-lg ml-auto" data-id="element-601" data-mp="eln696swwlg9">
            <Share2 className="w-4 h-4" data-id="element-602" data-mp="n1mfpyah6whk" /> Share
          </button>
        </div>
      </article>

      {/* Comments */}
      <section className="mt-6" aria-label="Comments" data-id="element-603" data-mp="r26e156sc65a">
        <h2 className="text-base font-serif font-bold text-navy-900 mb-4" data-id="element-604" data-mp="vu7oqmob1ot7">
          {comments.length} {comments.length === 1 ? 'Comment' : 'Comments'}
        </h2>

        <form onSubmit={submit} className="flex items-center gap-3 mb-6" data-id="element-605" data-mp="10vn6a4r9xd6u">
          <img src={user.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-606" data-mp="45cv0s52j7ol" />
          <input value={draft} onChange={e => setDraft(e.target.value)} placeholder="Write a comment…" className="flex-1 bg-white border border-navy-100 rounded-full px-4 py-2.5 text-sm text-navy-900 placeholder:text-navy-400 focus:outline-none focus:ring-2 focus:ring-gold-400/40" data-id="element-607" data-mp="866l9s5zgykn" />
          <button type="submit" className="p-2.5 bg-gold-500 text-navy-900 rounded-full hover:bg-gold-400 transition-colors" aria-label="Post comment" data-id="element-608" data-mp="1olr949wn18ws">
            <Send className="w-4 h-4" data-id="element-609" data-mp="32h9dzvfhfsge" />
          </button>
        </form>

        <ul className="space-y-4" data-id="element-610" data-mp="2xhwkiru3vn4u">
          {comments.map(c => <li key={c.id} className="flex gap-3" data-id="element-611" data-mp="3bh5xlin0m14l">
              <img src={c.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-612" data-mp="3bdqhcchlum1l" />
              <div className="bg-white border border-navy-100 rounded-2xl rounded-tl-sm px-4 py-2.5 flex-1" data-id="element-613" data-mp="36foxvqg9okpl">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-614" data-mp="3lc682ecpztak">
                  <span className="text-sm font-bold text-navy-900" data-id="element-615" data-mp="3ge4n1nvqhjwg">
                    {c.author}
                  </span>
                  <span className="text-xs text-navy-400" data-id="element-616" data-mp="3u5szjs9waady">{c.time}</span>
                </div>
                <p className="text-sm text-navy-700" data-id="element-617" data-mp="3q5itkfm3rjz3">{c.body}</p>
              </div>
            </li>)}
        </ul>
      </section>
    </div>;
}